export default {
  Inputfield: "Bitte eingeben ",
  Dropdownfield: "Bitte auswählen",
  Searchfield: "Suchen <object name>",
};
